// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"table_tableWrapper__3V7qC","table":"table_table__12DSQ","headerCell":"table_headerCell__27KTr"};